'use client'

import type { FlagValuesType } from 'flags'

import { useSearchParams } from 'next/navigation'

import camelCase from 'lodash/fp/camelCase'
import kebabCase from 'lodash/fp/kebabCase'
import snakeCase from 'lodash/fp/snakeCase'

import type { ChildrenProps } from '../types'

import FeatureFlagsContext from '../contexts/FeatureFlagsContext'

type Props = {
  flags: FlagValuesType
} & ChildrenProps
export default function FeatureFlagsProvider({ children, flags }: Props) {
  const searchParams = useSearchParams()

  const overriddenFlags = Object.fromEntries(
    Object.entries(flags).map(([key, value]) => {
      let override = null

      if (
        searchParams?.has(key) ||
        searchParams?.has(camelCase(key)) ||
        searchParams?.has(snakeCase(key)) ||
        searchParams?.has(kebabCase(key))
      ) {
        const overrideValue =
          searchParams.get(key) ??
          searchParams.get(camelCase(key)) ??
          searchParams.get(snakeCase(key)) ??
          searchParams.get(kebabCase(key))
        if (overrideValue === 'true') {
          override = true
        } else if (overrideValue === 'false') {
          override = false
        } else {
          override = overrideValue
        }
      }

      return [key, override ?? value]
    }),
  )

  return (
    <FeatureFlagsContext.Provider value={overriddenFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
